export const DropdownMenuConstants = Object.freeze({
  // NB: these "in-band" values can collide with dropdown values, so pick numbers that are "unlikely"
  CREATE_NEW_ITEM_REF: -1337133713,
  RESET_ITEM_REF: -1337133714,
  MONITORED_PAGES_FILTER_SHOW_EVERYONE: -1337133715,
  VIEW_AS_DONE_PREVIEWING_ID: -1337133716
});
